import api from './axios';
import type { Product } from '../types/product';

export interface NewProductCategory {
  id: number;
  name: string;
  nameZh: string;
  nameCn: string;
  description: string;
  descriptionZh: string;
  descriptionCn: string;
  isActive: boolean;
  parentId: number | null;
  createdAt: string;
  imageUrl: string | null;
}

export interface NewProductsResponse {
  products: Product[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface NewProductsParams {
  page: number;
  limit: number;
  sortBy: 'new' | 'popular' | 'price_low' | 'price_high';
  categoryId?: number;
}

export const newProductsApi = {
  // Get new product categories
  getNewProductCategories: async (): Promise<NewProductCategory[]> => {
    try {
      const response = await api.get('/api/shop/new-products/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching new product categories:', error);
      return [];
    }
  },

  // Get new products with optional category filter
  getNewProducts: async (params: NewProductsParams): Promise<NewProductsResponse> => {
    try {
      const queryParams = new URLSearchParams({
        page: params.page.toString(),
        limit: params.limit.toString(),
        sortBy: params.sortBy,
        ...(params.categoryId && { categoryId: params.categoryId.toString() }),
      });

      const response = await api.get(`/api/shop/new-products?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching new products:', error);
      throw error;
    }
    },
};
